import React from 'react';
import { actForFloor } from '../game/acts';

// v3.4: ACT badge shown in the map/HUD showing current act tint + name.
export default function ActBadge({ floor, testid }) {
  const act = actForFloor(floor);
  return (
    <div
      className="brutal-border-dim px-2 py-1 flex items-center gap-2 uppercase font-mono text-xs"
      data-testid={testid || 'act-badge'}
      style={{ borderColor: act.tint, color: act.tint, boxShadow: `2px 2px 0 ${act.tint}` }}
    >
      <span aria-hidden="true">{act.banner}</span>
      <span className="font-bold">{act.name}</span>
    </div>
  );
}
